import styled from 'styled-components'

export const DatabaseContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 24px;
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
  color: #ffffff;
`

export const DatabaseHeader = styled.div`
  margin-bottom: 20px;
  h2 {
    font-size: 24px;
    font-weight: 700;
    color: ${(props) => props.theme.titleColor};
    margin-bottom: 4px;
  }
  p {
    font-size: 13px;
    color: ${(props) => props.theme.subtitleColor};
  }
`

export const TabBar = styled.div`
  display: flex;
  gap: 8px;
  border-bottom: 1px solid ${(props) => (props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.08)')};
  margin-bottom: 24px;
`

export const TabItem = styled.button<{ $active: boolean }>`
  background: transparent;
  border: none;
  border-bottom: 2px solid ${props => props.$active ? '#3b82f6' : 'transparent'};
  color: ${props => props.$active ? (props.theme.name === 'light' ? '#0f172a' : '#ffffff') : (props.theme.name === 'light' ? '#64748b' : '#94a3b8')};
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Montserrat', sans-serif;

  &:hover {
    color: ${props => props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
  }
`

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${props => props.theme.name === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.04)'};
  border: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.08)'};
  border-radius: 12px;
  padding: 8px 16px;
  width: 100%;
  max-width: 320px;
  box-shadow: ${props => props.theme.name === 'light' ? '0 2px 8px rgba(0, 31, 92, 0.04)' : 'none'};
  
  svg {
    color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
  }

  input {
    background: transparent;
    border: none;
    outline: none;
    color: ${props => props.theme.textPrimary};
    font-size: 14px;
    width: 100%;
    font-family: 'Montserrat', sans-serif;

    &::placeholder {
      color: ${props => props.theme.name === 'light' ? '#94a3b8' : '#475569'};
    }
  }
`

export const FiltersGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const StyledSelect = styled.select`
  height: 38px;
  border-radius: 10px;
  border: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.08)'};
  background: ${props => props.theme.name === 'light' ? '#ffffff' : 'rgba(0, 24, 66, 0.8)'};
  color: ${props => props.theme.textPrimary};
  padding: 0 12px;
  font-size: 13px;
  font-family: 'Montserrat', sans-serif;
  outline: none;
  cursor: pointer;
  box-shadow: ${props => props.theme.name === 'light' ? '0 2px 8px rgba(0, 31, 92, 0.04)' : 'none'};

  option {
    background: ${props => props.theme.name === 'light' ? '#ffffff' : '#001842'};
    color: ${props => props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
  }
`

export const TableWrapper = styled.div`
  flex: 1;
  overflow: auto;
  background: ${props => props.theme.cardBackground};
  border: 1px solid ${props => props.theme.cardBorder};
  border-radius: 16px;
  margin-bottom: 16px;
  box-shadow: ${props => props.theme.name === 'light' ? '0 4px 20px rgba(0, 31, 92, 0.06)' : 'none'};

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
  }
`

export const ModernTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 13px;

  th {
    background: ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.03)'};
    padding: 14px 16px;
    color: ${props => props.theme.name === 'light' ? '#334155' : '#94a3b8'};
    font-weight: 700;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.5px;
    border-bottom: 1px solid ${props => props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.08)'};
    position: sticky;
    top: 0;
    z-index: 10;
  }

  td {
    padding: 12px 16px;
    border-bottom: 1px solid ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.04)'};
    color: ${props => props.theme.textPrimary};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 250px;
    font-weight: 500;
  }

  tr:hover td {
    background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(255, 255, 255, 0.02)'};
  }
`

export const StatusBadge = styled.span<{ $type: string }>`
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;

  background: ${props => {
    switch (props.$type?.toLowerCase()) {
      case 'ativo':
      case 'cadastrado':
        return 'rgba(34, 197, 94, 0.12)'
      case 'inativo':
      case 'ignorado':
        return 'rgba(239, 68, 68, 0.12)'
      case 'pendente':
      default:
        return 'rgba(234, 179, 8, 0.12)'
    }
  }};

  color: ${props => {
    switch (props.$type?.toLowerCase()) {
      case 'ativo':
      case 'cadastrado':
        return '#4ade80'
      case 'inativo':
      case 'ignorado':
        return '#f87171'
      case 'pendente':
      default:
        return '#facc15'
    }
  }};
`

export const ActionButton = styled.button`
  background: transparent;
  border: none;
  color: #3b82f6;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(59, 130, 246, 0.1);
    color: #60a5fa;
  }
`

export const Paginator = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;

  .info {
    font-size: 13px;
    color: #94a3b8;
  }

  .controls {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`

export const PageButton = styled.button`
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #ffffff;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
    border-color: #3b82f6;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`
